export default "__VITE_ASSET__CobiRbOu__"